import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import { AlertsSystemIcon, AlertsUserIcon, AlertsTemplateIcon } from "@icarius-icons/";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

const AlertsSettingsBox = () => {

  const data = [
    {
      name: getLocalizedString("systemAlertsSettings"),
      icon: <AlertsSystemIcon />,
      path: paths.systemAlertsSettings,
    },
    {
      name: getLocalizedString("userAlertsSettings"),
      icon: <AlertsUserIcon />,
      path: paths.userAlertsSettings,
    },
    {
      name: getLocalizedString("alertsTemplates"),
      icon: <AlertsTemplateIcon />,
      path: paths.alertsTemplates,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("alertAndNotificationDefinition")}
      data={data}
    />
  );
}

export default AlertsSettingsBox;
